import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

type Variant = 'primary' | 'secondary' | 'plain' | 'destructive';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'md' | 'lg';
  icon?: ReactNode;
  block?: boolean;
}

const variants: Record<Variant, string> = {
  primary: 'bg-button text-button-text active:opacity-80',
  secondary: 'bg-button/12 text-button active:bg-button/20',
  plain: 'text-link active:opacity-60',
  destructive: 'text-destructive active:opacity-60',
};

/** In-page buttons. The screen's primary action uses Telegram's MainButton (useMainButton). */
export function Button({
  variant = 'secondary',
  size = 'md',
  icon,
  block,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-xl text-center font-semibold leading-tight transition-[opacity,background-color] disabled:opacity-40',
        size === 'md' ? 'min-h-11 px-4 py-2 text-[16px]' : 'min-h-[50px] px-5 py-2.5 text-[17px]',
        variant === 'plain' || variant === 'destructive' ? 'min-h-0 px-0 py-1' : '',
        block && 'w-full',
        variants[variant],
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
